@if (!isInfoClosed()) {
  <mat-card class="info-card" [class.animate-in]="hasUserInteracted() && !isClosing()" [class.closing]="isClosing()">
    <mat-card-content>
      <div class="content-container">
        @if (icon()) {
          <div class="icon-container">
            <mat-icon class="banner-icon">{{ icon() }}</mat-icon>
          </div>
        }
        <div class="text-content">
          <div class="title">{{ title() }}</div>
          <ng-content />
        </div>
        <button (click)="closeInfo()" mat-icon-button class="close-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-card-content>
  </mat-card>
} @else {
  <div class="link-container" [class.animate-in]="hasUserInteracted()" (click)="reopenInfo()">
    <mat-icon>info</mat-icon>
    {{ 'AI_ASSISTANT.INFO_BANNER.WHATS_THIS' | translate }}
  </div>
}
